import RequestTransferAddressDialog from "./requestTransferAddressDialog.container";

export default RequestTransferAddressDialog;
